<template>
  <v-card>
    <v-card-title>
      <div>
        <div class="headline">Promotion Factors</div>
      </div>
      <v-spacer></v-spacer>
      <v-flex xs6>
        <v-text-field append-icon="mdi-magnify" label="Search" single-line hide-details v-model="search"></v-text-field>
      </v-flex>
    </v-card-title>
    <v-data-table v-bind:headers="headers" v-bind:items="items" v-bind:search="search" :rows-per-page-items="itemsPerPage" v-bind:pagination.sync="pagination" item-key="product" :loading="loading" :no-data-text="noDataText" :filter="customSearch">
      <template slot="items" slot-scope="props">
        <td>{{ props.item.product }}</td>
        <td class="text-xs-left">{{ props.item.productDesc }}</td>
        <td class="text-xs-left">{{ props.item.fact1 }}</td>
        <td class="text-xs-left">{{ props.item.fact2 }}</td>
        <td class="text-xs-left">{{ props.item.fact3 }}</td>
        <td class="text-xs-left">{{ props.item.fact4 }}</td>
        <td class="text-xs-left">{{ props.item.fact5 }}</td>
        <td class="text-xs-left">{{ props.item.fact6 }}</td>
        <td class="text-xs-right">
          <table-action :rowData="props" query @query="doQuery(props.item)" :loading="loading"></table-action>
        </td>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import * as TableConst from '@/mixins/table'
import { expandURI } from '@/utils/ajax'
import { PROMOTION_PROMOFACT, PROMOTION_PROMOFACT_TABMENU } from '@/store/types'

export default {
  data() {
    return {
      headers: [
        { text: 'Product Code', align: 'left', value: 'product', sortable: false },
        { text: 'Product Description', align: 'left', value: 'productDesc', sortable: false },
        { text: 'Factor 1', align: 'left', value: 'fact1', sortable: false },
        { text: 'Factor 2', align: 'left', value: 'fact2', sortable: false },
        { text: 'Factor 3', align: 'left', value: 'fact3', sortable: false },
        { text: 'Factor 4', align: 'left', value: 'fact4', sortable: false },
        { text: 'Factor 5', align: 'left', value: 'fact5', sortable: false },
        { text: 'Factor 6', align: 'left', value: 'fact6', sortable: false },
        TableConst.tableActionHeader
      ],
      totalItems: 0,
      loading: false,
      items: []
    }
  },
  methods: {
    async doInit() {
      const commitData = {
        promoFactTab: 0,
        displayRateTab: false,
        product: undefined
      }
      this.$store.commit(PROMOTION_PROMOFACT_TABMENU, commitData)
      await this.queryPromotionFactors()
    },
    async queryPromotionFactors() {
      const apiURI = this.$store.state.promotionManagement.promotion.menu.promotionFactors
      if (apiURI) {
        try {
          this.loading = true
          const expand = {
            promotion: this.promotion
          }
          const result = await this.$http.get(expandURI(apiURI, expand))
          if (result.data) {
            this.totalItems = result.data.totalElements
            const { data } = result.data
            if (data) {
              // Format the data here
              this.items = []
              data.map((promotionFactor) => {
                const convertPromotionFactor = {
                  promotion: promotionFactor.promotion,
                  promotionDesc: promotionFactor.promotionDesc,
                  product: promotionFactor.product,
                  productDesc: promotionFactor.productDesc,
                  fact1: promotionFactor.fact1,
                  fact2: promotionFactor.fact2,
                  fact3: promotionFactor.fact3,
                  fact4: promotionFactor.fact4,
                  fact5: promotionFactor.fact5,
                  fact6: promotionFactor.fact6
                }
                this.items.push(convertPromotionFactor)
              })
            } else {
              this.items = []
            }
          }
          this.loading = false
        } catch (err) {
          throw err
        }
      } else {
        this.$snotify.error('Invalid API URL')
      }
    },
    doQuery(data) {
      const promoFactors = {
        fact1: data.fact1,
        fact2: data.fact2,
        fact3: data.fact3,
        fact4: data.fact4,
        fact5: data.fact5,
        fact6: data.fact6
      }
      const commitData = {
        promoFactTab: 1,
        displayFactReviewTab: true,
        product: data.product
      }
      this.$store.commit(PROMOTION_PROMOFACT, promoFactors)
      this.$store.commit(PROMOTION_PROMOFACT_TABMENU, commitData)
      this.$router.push({ name: 'factorQuery', params: { product: data.product } })
    }
  },
  props: {
    promotion: {
      type: String,
      default: ''
    }
  },
  created() {
    this.doInit()
  },
  mixins: [
    TableConst.default
  ]
}
</script>

<style lang="scss">
</style>
